/**
 * @generated SignedSource<<0caf3819b66d2fe173096b1889df42cc>>
 * @relayHash 6b69db161a9dcc3f83b96372fa9ed8e9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID cac83ef399c40c3d7b17336627c1818a1bf7c894eded53ac4cb6b6beba752ab8

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { src_jiraBusinessBoardEmbedQuery } from './src_jiraBusinessBoardEmbedQuery.graphql';

const node: PreloadableConcreteRequest<src_jiraBusinessBoardEmbedQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "cac83ef399c40c3d7b17336627c1818a1bf7c894eded53ac4cb6b6beba752ab8",
    "metadata": {},
    "name": "src_jiraBusinessBoardEmbedQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
